import React from 'react';
import styled from 'styled-components';
import { useHistory } from 'react-router-dom';

import { Button } from 'components'
import { Header, Footer, CallToAction } from 'features'
import { FaCheck, FaArrowLeft, FaBolt, FaCalendarCheck, } from 'react-icons/fa'

const buttonStyle = {
    backgroundColor: 'var(--focus-color)',
    margin: '5rem 0 0 0',
    fontWeight: 'bold',
    padding: '0.5rem'
}

const Container = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;
    min-height: 100vh;
    background-color: #2B2B2B;
`

const Title = styled.div`
    font-weight: bold;
    font-size: 2rem;
    text-align: center;
    width: 100%;
    margin: 2rem 0;
`

const Body = styled.div`
    /* display: grid;
    grid-template-columns: 47.5% 47.5%;
    grid-column-gap: 5%; */
    justify-items: center;
    align-self: center;
    display: flex;
    @media (max-width: 800px) {
        flex-direction: column;
    }
`

const PlanContainer = styled.div`
    background-color: var(--secondary-color);
    padding: 1rem;
    border-radius: 5px;
    box-shadow: var(--box-shadow);
    width: 20rem;
    max-width: 40vw;
    margin: 1rem;
    display: flex;
    flex-direction: column;
    @media (max-width: 800px) {
        width: 80vw;
        max-width: 80vw;
        margin: 1rem 0;
    }
`

// Features components
const PlanTitle = styled.div`
    font-weight: bold;
`

const PlanTile = styled.div`
    display: grid;
    grid-template-columns: 1rem 1fr;
    grid-column-gap: 0.5rem;
    padding: 0.75rem 0 0 0;
`

const Line = styled.hr`
    border-color: var(--secondary-accent-color);
    width: 100%;
    margin-block-end: 0.25rem;
    margin-block-start: 0.75rem;
`;

// Price components
const PriceWrapper = styled.div`
    background-color: var(--primary-color);
    margin: 0.5rem 0;
    box-shadow: var(--box-shadow);
    border-radius: 5px;
    padding: 1rem;
    display: flex;
    align-items: center;
    justify-content: center;
`

const PriceContainer = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: flex-start;
    width: fit-content;
    align-self: center;
`

const Row = styled.div`
    display: flex;
`

const PriceTag = styled.div`
    font-weight: bold;
    font-size: 2rem;
`

const PriceSubTag = styled.div`
    /* border: 1px solid var(--secondary-accent-color); */
    border-radius: 10px;
    padding: 0.2rem 0rem;
    color: var(--secondary-accent-color);
    font-size: 0.8rem;
    margin: ${props => props.margin};
`

const Icon = styled.div`
    color: #fff;
    text-align: center;
    height: 1rem;
    width: 1rem;
    @media (max-width: 800px) {
        transform: rotate(90deg);
    }
`

const Icon2 = styled.div`
    text-align: center;
    align-self: center;
    justify-self: center;
    height: 1rem;
    width: 1rem;
`

const Label = styled.div`
    background-color: var(--primary-color);
    font-size: 0.6rem;
    border-radius: 10px;
    padding: 0.2rem 0.5rem;
    margin: 0 0.2rem;
    display: flex;
    align-items: center;
    justify-content: center;
`

const check = <FaCheck style={{color: '#fff'}}/>
const ref = {
    PERSONAL: {
        base: [
            { text: 'Up to 1000 tasks and 5 pages', icon: check },
        ],
        features: [
            { text: 'List and Kanban view', icon: check },
            { text: 'Command bar', icon: check },
            { text: 'Notifications', icon: check },
            { text: 'Tags', icon: check },
        ]
    },

    PREMIUM: {
        base: [
            { text: 'Unlimited tasks and pages', icon: check },
        ],
        features: [
            { text: <div style={{fontWeight: 'bold'}}>Everything in Personal</div>, icon: <Icon><FaArrowLeft/></Icon> },
            { text: 'Integrations', icon: <Icon2><FaBolt style={{color:'#e9c46a'}}/></Icon2> },
            { text: 'Calendars', icon: <Icon2><FaCalendarCheck style={{color:'#8ecae6'}}/></Icon2>  },
            // { 
            //     text: <div style={{display: 'flex'}}>
            //         Recurring tasks
            //         <Label>Coming soon</Label>
            //     </div>, 
            //     icon: check 
            // },
        ]
    }
}

const PricingScreen = props => {
    const {} = props;
    let history = useHistory()
    

    const createBlocks = (plan) => {
        let blocks = []
        ref[plan]['base'].map(row => {
            blocks.push(
                <PlanTile>
                    {row['icon']}
                    {row['text']}
                </PlanTile>
            )
        })
        blocks.push(<Line/>)

        ref[plan]['features'].map(row => {
            blocks.push(
                <PlanTile>
                    {row['icon']}
                    {row['text']}
                </PlanTile>
            )
        })

        return blocks
    }

    return (
        <Container>
            <Header/>  
            <Title>Pricing</Title>
            <Body>
                <PlanContainer>
                    <PlanTitle>Personal</PlanTitle>
                    <PriceWrapper>
                        <PriceContainer>
                            <Row>
                                <PriceTag>Free</PriceTag>
                            </Row>
                            <PriceSubTag>For individuals</PriceSubTag>
                        </PriceContainer>
                    </PriceWrapper>
                    {createBlocks('PERSONAL')}
                    <Button text='Get started' styles={buttonStyle} onSelect={() => history.push('/register')}/>
                </PlanContainer>
                
                <PlanContainer>
                    <PlanTitle>Premium</PlanTitle>
                    <PriceWrapper>
                        <PriceContainer>
                            <Row>
                                <PriceTag>$3</PriceTag>
                                <PriceSubTag margin='0 0 0 0.5rem'>
                                    per month
                                    <br/>
                                    billed annually
                                </PriceSubTag>
                            </Row>
                            <PriceSubTag>$4 billed monthly</PriceSubTag>
                        </PriceContainer>
                    </PriceWrapper>
                    {createBlocks('PREMIUM')}
                    <Button text='Try for Free' styles={buttonStyle} onSelect={() => {
                        localStorage.setItem('redirect', 'settings-subscription')
                        history.push('/login')
                    }}/>
                </PlanContainer>
            </Body>

            <CallToAction/>
            <Footer/>
        </Container>
    )
}

export default PricingScreen;